<template>
  <div class="purchase col-12">
    <div class="row justify-content-between purchaseHeader">
      <div class="col-12 col-md-6">
        <div class="col-12">
          <strong>Order Placed: </strong>{{item.transaction_date}}
        </div>
        <div class="col-12"><strong>Invoice #:</strong> {{item.invoice_number}}</div>
      </div>
      <div class="col-12 col-md-6 nopad">
        <div class="col-12"><strong>Total: </strong>${{details.cart_total}}</div>
        <div class="col-12"><strong>Savings: </strong>{{CurrencyFormatter(Math.abs(details.retail_total-details.cart_total))}}</div>
      </div>
    </div>
    <div class="row purchaseContent">
      <div class="col-12 col-md-6">
        <span v-if="details.delivery_details">
          <span class="font-weight-bold">Delivery Details</span>
          <br>
          {{details.delivery_details.given_name}} {{details.delivery_details.family_name}}
          <br>
          {{details.delivery_details.delivery_street_address}}
          <br>
          {{details.delivery_details.delivery_suburb}}
          <br>
          {{details.delivery_details.delivery_city}}
          <br>
          {{details.delivery_details.postcode}}
          <br>
        </span>
      </div>

      <div class="col-12 col-md-6">
        <span v-if="details.billing_details">
          <span class="font-weight-bold">Billing Details</span>
          <br>
          {{details.billing_details.given_name}} {{details.billing_details.family_name}}
          <br>
          {{details.billing_details.billing_street_address}}
          <br>
          {{details.billing_details.billing_suburb}}
          <br>
          {{details.billing_details.billing_city}}
          <br>
          {{details.billing_details.postcode}}
          <br>
        </span>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Items</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Item Total</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(cartGroup, key) in cart">
          <tr v-for="(item, productKey) in cartGroup.items" :key="key + '-' + productKey">
              <td>{{item.product.title}} - {{item.product.product_code}} <br>
              Optimised Freight: <span v-if="cartGroup.freight_info.optimised_freight.toLowerCase() == 'no optimise'">No</span><span v-else>Yes</span><br>
              Delivery Option: {{cartGroup.selected_delivery}}
              </td>
              <td>{{item.settings.quantity}}</td>
              <td>{{CurrencyFormatter(item.product.member_price.price)}}</td>
              <td>{{CurrencyFormatter(item.line_total)}}</td>
            </tr>
          </template>
          <tr class="font-weight-bold">
            <td>Items total</td>
            <td></td>
            <td></td>
            <td>{{CurrencyFormatter(details.items_total)}}</td>
          </tr>
          <tr class="font-weight-bold" v-if="'combined_freight_total' in details && details.combined_freight_total > 0">
            <td>Optimised items additional freight</td>
            <td></td>
            <td></td>
            <td>{{CurrencyFormatter(details.combined_freight_total)}}</td>
          </tr>
          <tr class="font-weight-bold" v-if="details.freight_total">
            <td>Order Freight Total</td>
            <td></td>
            <td></td>
            <td>{{CurrencyFormatter(details.freight_total)}}</td>
          </tr>
          <tr class="font-weight-bold">
          <td>Order Total</td>
          <td></td>
          <td></td>
          <td>{{CurrencyFormatter(details.cart_total)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="details.cart_points">
      Points Earned {{details.cart_points}}
    </div>
  </div>
</template>

<script>
import {CurrencyFormatter} from "@/utils";

export default {
  name: "OrderItem",
  components: {

  },
  props: ["item"],
  methods:{
    CurrencyFormatter
  },
  computed: {
    details() {
      return this.item.transaction_details;
    },
    cart(){
      return this.details.cart_details;
    },
    orderItems() {
      let cart = this.details.cart_details;

      let items = [];
      //unnset all the freight rules
      Object.values(cart).forEach(group => {
        let prodItems = group.items;
        Object.values(prodItems).forEach(item => {
          items.push(item);
        });
      });

      return items;
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase {
  overflow: hidden;
  margin-bottom: 20px;
  // background:lightgrey;
  // padding:20px;
  border: 1px solid #eee;
  border-radius: 10px 10px 0 0;
  // box-shadow: 1px 2px 6px 0px #aaa;

  .purchaseHeader {
    background: #eee;
    // border-bottom:1px solid grey;
    padding: 5px;
  }
  .purchaseContent {
    padding: 20px;
  }
}
@include media-breakpoint-up(md){

  .nopad{
    padding:0;
  }
}
</style>
